import React, {use, useEffect} from "react";
import "./portfolioNetworthGraph.css";
import {Helmet} from "react-helmet";
import Header2 from "../../common/header/Header2";
import MainContent from "./others/MainContent";
import {Link, useLocation, useNavigate, useParams} from "react-router-dom";
import BottomNavigationApp from "./others/BottomNavigation";
import {drawerWidth, isDesktop} from "../../common/constants";
import json2mq from "json2mq";
import UserAvatar from "../userAvatar";
import PromoBanner from "../promoBanner";
import {IconButton, useMediaQuery} from "@mui/material";
import {ReactComponent as NotificationIcon} from "../../pages/account/profile/profile_icon/notification-icon.svg";
import {tabLink} from "../../common/constant/tablink";
import BottomTab from "../../common/hooks/BottomTab";
import LoginPopUp from "../../common/alert/login/LoginPopUp";

const PortfolioNetworthGraph = (props) => {
    const [isLoginModalOpen, setLoginModalOpen] = React.useState(false);
    const navigate = useNavigate();
    const location = useLocation();

    const {indexName} = useParams();
    const index = indexName ? indexName.split("-")[0] : "Crypto";
    const [index_name, setIndexName] = React.useState(index);
    const mediaQueryVar = useMediaQuery(json2mq(isDesktop));

    const handleModalClose = () => {
        // Close the modal and reset the URL to the welcome page
        setLoginModalOpen(false);
        navigate(location.pathname, {replace: true});
    };

    React.useEffect(() => {
        const index = indexName ? indexName.split("-")[0] : "Crypto";
        setIndexName(index);
    }, [indexName]);

    const userData = JSON.parse(localStorage.getItem("cw_portfolio_user"));

    const [unreadAlerts, setUnreadAlerts] = React.useState(0);
    React.useEffect(() => {
        const userId = userData?.user_id || null;

        const fetchAlertsCount = async () => {
            try {
                const formData = new URLSearchParams();
                formData.append("user_id", userId); // convert to form-encoded format

                const response = await fetch("https://crowdwisdom.live/wp-json/api/v1/crypto_alerts_count", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded", // ✅ no preflight
                    },
                    body: formData, // ✅ correct format for this content type
                });

                if (!response.ok) {
                    throw new Error(`Error: ${response.status}`);
                }

                const data = await response.json();
                console.log(data);
                setUnreadAlerts(data.unread_notifications);
            } catch (error) {
                console.error("Failed to fetch alerts:", error);
            }
        };

        fetchAlertsCount();
    }, []);
    const [path, setPath] = React.useState("/");

    const handleLoginClick = () => {
        window.history.pushState({}, "", "/login");
        localStorage.setItem("isPopupManuallyOpened", "true");
        setLoginModalOpen(true);
    };
    React.useEffect(() => {
        if (typeof window !== "undefined") {
            setPath(window.location.pathname);
        }
    }, []);

    const TopNavigationDesktop = ({unreadAlerts}) => {
        const isActive = (href) => path === href;

        const topTabStyle = (active) => ({
            display: "flex",
            alignItems: "center",
            padding: "4px 13px",
            borderRadius: "999px",
            backgroundColor: active ? "#ffffff" : "transparent",
            color: active ? "#1877F2" : "#ffffff",
            fontWeight: active ? "600" : "500",
            fontSize: "16px",
            cursor: "pointer",
            border: active ? "2px solid #ffffff" : "none",
        });

        const iconFilter = (active) =>
            active
                ? "invert(29%) sepia(98%) saturate(1502%) hue-rotate(189deg) brightness(100%) contrast(97%)"
                : "brightness(0) invert(1)";

        return (
            <div style={{padding: "20px", background: "#ffffff", boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)"}}>
                {/* Top Navigation */}
                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        margin: "0 auto",
                    }}
                >
                    {/* Left Tabs */}
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                            backgroundColor: "#1877F2",
                            padding: "5px 5px",
                            borderRadius: "50px",
                        }}
                    >
                        {[tabLink["indices"], tabLink["influencer_ranking_prediction"], tabLink["screener"]].map(
                            (tab, index) => (
                                <Link to={tab.href} key={index} style={{textDecoration: "none", minWidth: "150px"}}>
                                    <div style={topTabStyle(isActive(tab.href))}>
                                        <img
                                            src={window?.constants?.asset_path + tab.icon}
                                            alt="icon"
                                            style={{
                                                marginRight: "6px",
                                                height: tab.icon_width || "25px",
                                                filter: iconFilter(isActive(tab.href)),
                                            }}
                                        />
                                        {!mediaQueryVar ? tab.mobile_name : tab.name}
                                    </div>
                                </Link>
                            )
                        )}
                    </div>

                    {/* Notification Bell */}
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "flex-end",
                            gap: "5px",
                            marginRight: "15px",
                        }}
                    >
                        {/* Notification Bell */}
                        <div
                            onClick={() => (window.location.href = "/alerts")}
                            style={{position: "relative", cursor: "pointer"}}
                        >
                            <NotificationIcon className="notification-icon fa-2x" />
                             {/* Desktop */}
                        <div
                                style={{
                                    position: "absolute",
                                    top: "-6px",
                                    right: "2px",
                                    backgroundColor: "#c0392b",
                                    minWidth: unreadAlerts < 100 ? "20px": "27px",
                                    height: unreadAlerts < 100 ? "20px": "27px",
                                    borderRadius: "50%",
                                    fontSize: "11px",
                                    color: "#fff",
                                    textAlign: "center",
                                    lineHeight: "20px",
                                    fontWeight: "bold",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    padding: "0 4px",
                                }}
                                >
                                {unreadAlerts < 100 ? unreadAlerts : "99+"}
                                </div>
                        </div>

                        <UserAvatar />
                    </div>
                </div>

                {/* Bottom Tabs */}
                <BottomTab
                    tabs={[
                        tabLink["subscription"],
                        userData ? tabLink["my_portfolio"] : tabLink["presale"],
                        tabLink["profile"],
                    ]}
                    handleLoginClick={handleLoginClick}
                />
            </div>
        );
    };

    const bottomNavigationMobile = [
        tabLink["subscription"],
        userData ? tabLink["my_portfolio"] : tabLink["portfolio_audit"],
        tabLink["profile"],
    ];
    const topNavigationMobile = [tabLink["indices"], tabLink["influencer_ranking_prediction"]];
    return (
        <div className="Indices-page">
            <Helmet>
                <title>Crowdwisdom360 {index_name} Indices</title>
            </Helmet>
            <div>
                {mediaQueryVar ? (
                    <div
                        style={{
                            position: "fixed",
                            top: 0,
                            left: drawerWidth,
                            width: `calc(100% - ${drawerWidth}px)`,
                            backgroundColor: "#ffffff",
                            zIndex: 1000,
                            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                            height: "100px", // You may need to increase this if banner + nav exceeds 100px
                            display: "flex",
                            flexDirection: "column",
                        }}
                    >
                        <PromoBanner />
                        <TopNavigationDesktop unreadAlerts={unreadAlerts} />
                    </div>
                ) : null}
                <Header2
                    index={index_name}
                    bottomNavigationMobile={bottomNavigationMobile}
                    topNavigationMobile={topNavigationMobile}
                >
                    <h6
                        style={{
                            textAlign: mediaQueryVar ? "left" : "center", // Simplified the condition
                            paddingLeft: mediaQueryVar ? "340px" : "0", // Adjust padding based on screen size
                        }}
                    >
                        <span
                            style={{
                                fontSize: "24px",
                                fontFamily: "Satoshi,sans-serif",
                                fontWeight: mediaQueryVar ? "700" : "",
                            }}
                        >
                            Cryptocurrency
                            {mediaQueryVar ? (
                                "Indices"
                            ) : (
                                <span className="bg-primary px-2 py-1 rounded text-white">Indices</span>
                            )}
                        </span>
                    </h6>
                </Header2>
                <div style={{marginTop: mediaQueryVar ? "200px" : "100px"}}>
                    <MainContent setIndexName={setIndexName} index={index_name} setLoginModalOpen={setLoginModalOpen} />
                </div>
                <BottomNavigationApp setLoginModalOpen={setLoginModalOpen} />
                {isLoginModalOpen && (
                    <LoginPopUp
                        // isLoginModalOpen={isLoginModalOpen}
                        setLoginModalOpen={setLoginModalOpen} // Pass the state setter down
                        onClose={handleModalClose}
                    />
                )}
            </div>
        </div>
    );
};

export default PortfolioNetworthGraph;
